import { render, staticRenderFns } from "./GerdHelpLogo.vue?vue&type=template&id=fa76163e&scoped=true"
import script from "./GerdHelpLogo.vue?vue&type=script&lang=js"
export * from "./GerdHelpLogo.vue?vue&type=script&lang=js"
import style0 from "./GerdHelpLogo.vue?vue&type=style&index=0&id=fa76163e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa76163e",
  null
  
)

export default component.exports